<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong>Párosítás</strong>
			</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'import', ban_record ],
				fields: [
					{
						type: 'text',
						name: 'name',
						title: 'Név',
						attributes: {
							readonly: true
						}
					},
					{
						type: 'text',
						name: 'ban',
						title: 'Bankszámlaszám'
					},
					{
						type: 'select',
						name: 'company_id',
						title: 'Cég',
						params: {
							maxItems: 1,
							options: Anvil.page.companies.data,
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'tax_number', 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
							}
						},
						unset_value: null
					}
				]
			}) %>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.link()"><i class="fa fa-link me-2"></i>Párosítás</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async link () {
		Anvil.exec('company_ban/action_link_ban', Anvil.page.modal.ban_record)
	}
})
</script>
